import styled from 'styled-components';

const StyledSkipLink = styled.a`
  position: absolute;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
  clip: rect(1px, 1px, 1px, 1px);
  padding: 10px;
  left: 50%;
  transform: translateX(-50%);
  top: 20px;
  color: #fff;
  background: #000;

  span {
    display: block;
  }

  &:focus {
    position: absolute;
    width: auto;
    height: auto;
    clip: auto;
    z-index: 999;
  }
`;

export default StyledSkipLink;
